// Add or remove ONE id on a control's aria-describedby, keeping every other
// description the host already attached (a hint, a server error, another
// controller's alert) intact. The attribute is a space-separated id list and
// several writers can share one input — org_confirm_gate_controller's lookup
// error and imo_agency_controller's lock hint both describe the profile's
// agency field — so nobody may set or clear the whole attribute: a writer that
// clobbers it silently disconnects a neighbour's still-visible description
// from the field (#13424 review). Removing the last id removes the attribute.
export function describeInputBy(input, id, present) {
  if (!input || !id) return

  const ids = (input.getAttribute("aria-describedby") || "").split(/\s+/).filter((token) => token && token !== id)
  if (present) ids.push(id)
  if (ids.length === 0) {
    input.removeAttribute("aria-describedby")
  } else {
    input.setAttribute("aria-describedby", ids.join(" "))
  }
}
